import NFTItem from "../nft-item";
import NFT from '../../assets/images/nft.png'
import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from "react";
export default function Box() {
    const listNFT = [
        {
            name: 'Lorem ipsum',
            id: '1',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '2',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '3',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '4',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '5',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '6',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '7',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '8',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '9',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '10',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '11',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '12',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '13',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '14',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },
        {
            name: 'Lorem ipsum',
            id: '15',
            tire: '01',
            price: '123,456,789.00',
            img: NFT
        },

    ]
    const itemPerPage = 12
    const numberPage = Math.ceil(listNFT.length / itemPerPage)
    const location = useLocation()
    //console.log(location.pathname)
    const [path, setPath] = useState(() => {
        if (location.pathname === '/marketplace') {
            //console.log(1)
            return ('/marketplace/')
        }
        if (location.pathname === '/inventory') {
            return ('/inventory/')
        }
        if (location.pathname === '/inventory') {
            return ('/inventory/')
        }
        
        return ('deo on')
    })
    const [currentList, setCurrentList] = useState(() => { return (listNFT.slice(0, 12)) })
    const [currentPage, setCurrentPage] = useState(0)
    useEffect(() => {
        setCurrentList(() => {
            return listNFT.slice(currentPage * itemPerPage, (currentPage + 1) * itemPerPage)
        })
    }, [currentPage])
    //console.log(path)
    //console.log(currentList)
    function handlePrevPage() {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1)
        }
    }
    function handleNextPage() {
        if (currentPage < numberPage - 1) {
            setCurrentPage(currentPage + 1)
        }
    }
    return (
        <>
            <div className=" w-full grid  grid-cols-2   md:grid-cols-3 gap-[3rem] ">
                {currentList.map((item, index) =>
                    <div key={index} className="">
                        <Link to={`/inventory/mint/${index}`}>
                            <NFTItem name={item.name} id={item.id} img={item.img} price={item.price} tire={item.tire} />
                        </Link>
                    </div>
                )}
            </div>
            <div className="flex justify-end items-center gap-[1.6rem] mt-[5rem]">

                <div onClick={handlePrevPage} className={`prev bg-transparent relative cursor-pointer transition-all rotate-180 duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-primary  border`}>
                    <div className="border-t-[0.4rem] -r-black rounded-tr-md border-r-[0.4rem] w-[1.8rem] h-[1.8rem] border-t-white border-r-white rotate-45 absolute top-[1.4rem] left-[1.2rem]">
                    </div>
                </div>
                {
                    Array.from(Array(numberPage), (e, i) => {
                        return (
                            <div onClick={() => setCurrentPage(i)} key={i} className={`${currentPage === i ? 'text-primary bg-third' : 'text-white bg-transparent'} cursor-pointer transition-all duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-third  border`}>
                                <p className={`text-[1.8rem] font-poppin `}>{i + 1}</p>
                            </div>
                        )
                    })
                }
                <div onClick={handleNextPage} className={` next  bg-transparent relative cursor-pointer transition-all duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-primary  border`}>
                    <div className="border-t-[0.4rem] -r-black rounded-tr-md border-r-[0.4rem] w-[1.8rem] h-[1.8rem] border-t-white border-r-white rotate-45 absolute top-[1.4rem] left-[1.2rem]">

                    </div>
                </div>
            </div>
        </>
    )

}